import React from 'react';
import TickerItem from './TickerItem';
import { privacyLaws } from '../../data/privacyLaws';

export default function TickerContent() {
  // Get unique law names from the privacyLaws array
  const lawNames = privacyLaws.map(law => law.name);

  return (
    <div className="flex whitespace-nowrap animate-ticker">
      {lawNames.map((law, index) => (
        <TickerItem key={index} text={law} />
      ))}
      {/* Duplicate for seamless loop */}
      {lawNames.map((law, index) => (
        <TickerItem key={`duplicate-${index}`} text={law} />
      ))}
    </div>
  );
}